import { createContext } from "@radix-ui/react-context";

interface CircleContextValue {
  size: number;
  borderRadius: number;
}

const [CircleContextProvider, useCircleContext] = createContext<CircleContextValue>("Circle.Root");

export { CircleContextProvider, useCircleContext };
